import { MessageDescriptor } from 'react-intl';

import FAQ from '@/components/homepageRefresh/homepage/FAQ';
import HomepageFAQ from '@/components/homepageRefresh/homepage/HomepageLayout/data/faq.mdx';
import {
	messages as defaultToolsMessages,
	sections as defaultToolsSections,
} from '@/components/homepageRefresh/homepage/HomepageLayout/data/tools';
import { GradientBg } from '@/components/homepageRefresh/homepage/HomepageLayout/styles';
import MentalHealthTools from '@/components/homepageRefresh/homepage/MentalHealthTools';
import { MentalHealthSlide } from '@/components/homepageRefresh/homepage/MentalHealthTools/types';
import ValueProps from '@/components/homepageRefresh/homepage/ValueProps';

import { AdditionalContentWrapper } from './styles';

const AdditionalContent = ({
	toolSections,
	toolMessages,
}: {
	toolSections?: Record<string, MentalHealthSlide>;
	toolMessages?: Record<string, MessageDescriptor>;
}) => {
	return (
		<AdditionalContentWrapper>
			<ValueProps />
			<GradientBg>
				<MentalHealthTools
					toolsSections={toolSections ?? defaultToolsSections}
					toolsHeading={toolMessages?.heading ?? defaultToolsMessages.heading}
					toolsCopy={toolMessages?.copy ?? defaultToolsMessages.copy}
				/>
			</GradientBg>
			<GradientBg>
				<FAQ FaqSections={HomepageFAQ} />
			</GradientBg>
		</AdditionalContentWrapper>
	);
};

export default AdditionalContent;
